import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';
import UploadQueue from 'components/UploadQueue';
import ReqLink from 'components/RequestsLink';
import {
  hasDocsForUpload,
  getUploadQueue,
  hasTitlesForChange,
  getUploadedTitlesQueue,
  manageQueue,
  prepareUsersManualOptions,
  prepareSupDocOptions
} from 'helpers/Uploads';
import {
  uploadUsersManual,
  uploadSupportDocument,
  addToQueue,
  removeFromQueue,
  clearQueue,
  deleteSupportDocument,
  updateSupDocTitle
} from 'actions/uploads';

class ResultPanel extends Component {
  componentDidMount() {
    const {
      request,
      isUpdate,
      addToQueue,
      uploadUsersManual,
      uploadSupportDocument,
      removeFromQueue
    } = this.props;
    const { supportDocs, newId, id, usersManual } = request;
    const requestId = newId || id;
    const modelId = request.deviceModelId || request.model.id;

    // uploading users manual
    if (usersManual && usersManual.file) {
      const uploadOptions = prepareUsersManualOptions(usersManual, modelId);
      manageQueue(
        uploadOptions,
        uploadUsersManual,
        addToQueue,
        removeFromQueue
      );
    }

    // uploading support documents
    if (hasDocsForUpload(supportDocs)) {
      const queue = getUploadQueue(supportDocs);
      _.map(queue, doc => {
        const { file, title, slot } = doc;
        const uploadOptions = prepareSupDocOptions(
          slot,
          title,
          file,
          requestId,
          isUpdate
        );
        manageQueue(
          uploadOptions,
          uploadSupportDocument,
          addToQueue,
          removeFromQueue
        );
      });
    }

    // update sup docs' titles
    if (hasTitlesForChange(supportDocs)) {
      const queue = getUploadedTitlesQueue(supportDocs);
      _.map(queue, doc => {
        this.props.updateSupDocTitle(requestId, doc.slot, doc.title);
      });
    }
  }

  componentWillUnmount() {
    this.props.clearQueue();
  }

  getResultTitle = () => {
    const { isSubmit, isUpdate } = this.props;

    if (isSubmit) return 'submitted';
    if (isUpdate) return 'updated';

    return 'saved';
  };

  render() {
    const { request } = this.props;
    const resTitle = this.getResultTitle();
    const reqNum = () => {
      if (!request.tn) return null;

      return <b>{request.tn}</b>;
    };

    return (
      <Alert bsStyle="warning">
        <p>
          <Glyphicon glyph="ok" style={{ marginRight: 10 }} />Request {reqNum()}{' '}
          has been successfully {resTitle}. You can review{' '}
          <ReqLink linkTitle="all your requests here" />.
        </p>
        <UploadQueue />
      </Alert>
    );
  }
}

ResultPanel.propTypes = {
  isSubmit: PropTypes.bool,
  isUpdate: PropTypes.bool,
  isSave: PropTypes.bool
};

ResultPanel.defaultProps = {
  isSubmit: false,
  isUpdate: false,
  isSave: false
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    uploadUsersManual,
    uploadSupportDocument,
    addToQueue,
    removeFromQueue,
    clearQueue,
    deleteSupportDocument,
    updateSupDocTitle
  }
)(ResultPanel);



// WEBPACK FOOTER //
// ./src/components/ResultPanel.js